import React, { useState, useEffect } from "react";
import api from "../../services/api";
import Button from "@material-ui/core/Button";
import { Tooltip } from "@material-ui/core";
import { TriangleAlert } from "lucide-react";
import { i18n } from "../../translate/i18n";

const packageVersion = require("../../../package.json").version;

const VersionControl = () => {
  const [storedVersion] = useState(
    window.localStorage.getItem("version") || "0.0.0"
  );
  const [isScreenWide, setIsScreenWide] = useState(true); // Estado para controlar a visibilidade

  const handleUpdateVersion = async () => {
    window.localStorage.setItem("version", packageVersion);

    // Mantive apenas para salvar no banco a versao atual
    const { data } = await api.post("/version", {
      version: packageVersion,
    });

    // Limpar o cache do navegador
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });

    // Atraso para garantir que o cache foi limpo
    setTimeout(() => {
      window.location.reload(true); // Recarregar a página
    }, 1000);
  };

  // Hook para verificar a largura da tela
  useEffect(() => {
    const handleResize = () => {
      // Define se a largura da tela for maior que 1366px
      setIsScreenWide(window.innerWidth > 1500);
    };

    // Definir a largura da tela inicial
    handleResize();

    // Adicionar o event listener para redimensionamento da tela
    window.addEventListener("resize", handleResize);

    // Limpar o event listener ao desmontar o componente
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "right",
        alignItems: "center",
        width: 35,
        height: 35,
        borderRadius: 20,
      }}
    >
      {storedVersion !== packageVersion && (
        <Tooltip
          title={i18n.t("appBarListem.newVersion")}
          arrow
          placement="bottom"
        >
          <div
            onClick={handleUpdateVersion}
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "rgba(78, 228, 18, 0.7)",
              color: "white",
              borderRadius: "50px",
              padding: "3px 10px",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <TriangleAlert
              style={{
                width: "22px",
                height: "22px",
                color: "white",
                
              }}
            />
            {/* Oculta o texto em telas menores */}
            {isScreenWide && <span style={{ marginLeft: "5px",fontSize: "13px" }}>Nova atualização</span>}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default VersionControl;
